export default {
  shopList: [],
  areaList: [],
  mapShopList: [],
  selectValues: {
    status: [],
    potential: [],
    rPerformance: [],
    type: [],
    bizStatus: [],
    arrTag: [],
    requestType: '2'
  },
  shopId: '',
  currentlyGeo: {
    myLng: '',
    myLat: '',
    lng: '',
    lat: ''
  }
}
